import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Component({
    selector: 'app-cig-congratulations',
    templateUrl: './cig-congratulations.component.html',
    styleUrls: ['./cig-congratulations.component.scss']
})
export class CigCongratulationsComponent implements OnInit {

    @Input() profile:Array<Object>;
    @Input() slides;
    @Input() author;
    public env;
    public profiles : any;
  
    constructor() { }

    ngOnInit() {
        this.env=environment;
        this.profiles = this.profile;
    }

    public ngOnChanges( changes: SimpleChanges ) : void {

        if ( changes.profile && ! changes.profile.isFirstChange() ) {
        	this.profiles = changes.profile.currentValue;

        }

    }

}
